import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";

// COMPONENTS:
import App from "./App";
import "./index.scss";
import "components/forms/yupErrorMessages";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// initialize datadog
// import "./utils/datadogInit";

// Suppress benign ResizeObserver loop warning from browser/MUI (harmless, no fix in our code)
const prevOnError = window.onerror;
window.onerror = (message: string | Event, ...args: any[]) => {
  if (
    typeof message === "string" &&
    message.includes(
      "ResizeObserver loop completed with undelivered notifications",
    )
  ) {
    return true; // suppress log
  }
  return prevOnError ? prevOnError(message, ...args) : false;
};

ReactDOM.render(<App />, document.getElementById("root"));

// Register service worker for PWA support
serviceWorkerRegistration.register();
